import { Box } from "@mui/material";
import React from "react";
import Sidebar from "../components/Layout/Sidebar";
import { PortfolioListView } from "../components/Portfolio";

const Portfolios: React.FC = () => {
  return (
    <Box sx={{ display: "flex", height: "100%", backgroundColor: "#1e1e1e" }}>
      <Sidebar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          ml: "60px", // Account for sidebar width
          overflow: "auto",
          backgroundColor: "#1e1e1e",
        }}
      >
        <PortfolioListView />
      </Box>
    </Box>
  );
};

export default Portfolios;
